<template>
  <div>
    <v-container class="px-0" fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="mb-5">
          <h1 class="primary--text font-weight-medium text-h5">
            {{ $t('twofactor_download_title') }}
          </h1>
        </v-col>
      </v-row>
      <v-row justify="center">
        <img
          src="@/assets/002_google_au.png"
          alt="Google Authenticator Logo"
          width="218"
          height="40"
          class="mx-2 mb-5"
        />
      </v-row>
      <v-divider />
      <v-row justify="center" class="mt-6 px-0 px-md-6">
        <v-col cols="12" md="10" class="text-center px-0 px-md-6">
          <span class="header">{{ $t('twofactor_download_content_2') }}</span>
          <div class="my-4 mt-6 d-flex align-center justify-center">
            <a
              class="d-flex align-center"
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              target="_blank"
            >
              <img
                src="@/assets/003_on_the_App_Store_Badge_US-UK_RGB_wht_092917.png"
                alt="App store link logo"
                width="120"
                height="40"
                class="mx-2"
              />
            </a>
            <a
              class="d-flex align-center"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
              target="_blank"
            >
              <img
                src="@/assets/004_on_the_playstore_Store_Badge_US-UK_RGB_wht_092917.png"
                alt="Play store link logo"
                width="135"
                height="40"
                class="mx-2"
              />
            </a>
            <v-btn outlined @click="toggleQR">
              <v-icon class="mr-2">mdi-qrcode-scan</v-icon>
              <span>{{ $t('twofactor_download_scan') }}</span>
            </v-btn>
          </div>
          <v-img
            v-if="showQR"
            contain
            lazy-src="@/assets/download_2fa_qr.png"
            src="@/assets/download_2fa_qr.png"
            alt="Scan QR to download"
            width="140"
            height="140"
            class="mx-auto mt-4"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-alert color="primary" outlined dark class="mb-0">
            <span class="text-body-1" v-html="$t('twofactor_download_note')" />
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="ma-0 pa-0" />
    <v-row align-content="center">
      <v-col cols="12" class="d-flex justify-space-between justify-md-end twoFactor--buttons">
        <slot name="before"></slot>
        <slot name="after"></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showQR: false
    }
  },
  methods: {
    toggleQR() {
      this.showQR = !this.showQR
    }
  }
}
</script>

<style scoped>
.header {
  text-align: center;
  font: normal normal 500 16px/22px 'Libre Franklin';
  letter-spacing: 0;
  color: #686F8D;
}

.divider--fix {
  margin: 0 -1px;
}
</style>
